import React from "react";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import StatusBadge from "./StatusBadge";
import LedgerSyncBadge from "./LedgerSyncBadge";
import { formatDateTime, statusAccentColor } from "./partnersMobileUtils";
import { getLedgerSyncStatus } from "../ledgerSyncUtils";
import css from "./partnersMobile.module.css";

// Header (CPID + chip + kebab) and the full field set come from
// partners-module.html; the tap-through to detail comes from README (1).md.
export default function PartnerCard({ row, onOpen, onAction }) {
  const title = row.billingName || row.name || "—";
  // Status-coloured left edge, as the CP Sourcing cards do per tier.
  const accent = statusAccentColor({ status: row.approvalStatus, disabled: row.Disabled });
  const sync = getLedgerSyncStatus(row);

  return (
    <div className={css.card} style={{ borderLeftColor: accent }}>
      <div className={css.cardHeader}>
        <span className={css.cardId}>{row.cpDisplayId}</span>
        <StatusBadge status={row.approvalStatus} disabled={row.Disabled} />
        <span className={css.cardHeaderSpacer} />
        <button
          type="button"
          className={css.kebab}
          aria-label={`Actions for ${row.cpDisplayId}`}
          onClick={(e) => {
            // The card body is also clickable — do not let this bubble into it.
            e.stopPropagation();
            onAction(row);
          }}
        >
          <MoreVertIcon sx={{ fontSize: 20 }} />
        </button>
      </div>

      <button type="button" className={css.cardBody} onClick={() => onOpen(row)}>
        <div className={css.cardTitle}>{title}</div>
        <div className={css.kv}>
          <span className={css.kvKey}>Contact</span>
          <span className={css.kvValue}>{row.name || "—"}</span>
        </div>
        <div className={css.kv}>
          <span className={css.kvKey}>Type</span>
          <span className={css.kvValue}>{row.type || "—"}</span>
        </div>
        <div className={css.kv}>
          <span className={css.kvKey}>Ledger Sync</span>
          <span>
            <LedgerSyncBadge row={row} />
            {/* Same Finance / CRM breakdown the desktop column shows. */}
            <span
              title="Finance / CRM ledger status"
              style={{ display: "block", marginTop: 4, fontSize: 12, color: "#667085" }}
            >
              Finance {sync.financeOk ? "✓" : "—"} · CRM {sync.crmOk ? "✓" : "—"}
            </span>
          </span>
        </div>
        <div className={css.cardFooter}>
          <div>Created {formatDateTime(row.createdAt)}</div>
          <div>Updated {formatDateTime(row.lastUpdated)}</div>
        </div>
      </button>
    </div>
  );
}
